// extracted by mini-css-extract-plugin
export var wholeLink = "ProjectSummary-module--wholeLink--MZECG";
export var projectlistboxes = "ProjectSummary-module--projectlistboxes--SpmOu";
export var imageformat = "ProjectSummary-module--imageformat--VL5pK";
export var imagery = "ProjectSummary-module--imagery--hHeFW";
export var imagecaption = "ProjectSummary-module--imagecaption--jeaSU";
export var linebreak = "ProjectSummary-module--linebreak--TGM0-";
export var projectcat = "ProjectSummary-module--projectcat--7WD8+";
export var projecttextbox = "ProjectSummary-module--projecttextbox--5HN8v";
export var projectdescription = "ProjectSummary-module--projectdescription--84pHx";